import { fromJS } from 'immutable'

const initialState = fromJS({
    selected: {
        name: '',
        type: '',
        dest: '',
        destText: '',
        place: '',
        placeContentType: '',
        placeContent: '',
        placeContentText: '',
        icon: "",
        img: '',
        imgDel: '',
        order: 0,
        id: 0,
    },
    destiny: {},
    editing: false,
    showDrawer: false
})

const appmenus = (state = initialState, action) => {
    switch (action.type) {
        case "SET_APP_MENU":
            return state.merge({
                selected: {
                    ...action.payload
                }
            })
        case "SET_APP_MENU_DESTINY":
            return state.merge({
                destiny: {
                    ...action.payload
                }
            })
        case "SET_APP_MENU_EDIT":
            return state.merge({
                selected: {
                    ...action.payload
                },
                destiny: {},
                editing: true
            })
        case "SET_APP_MENU_EDIT_CLOSE":
            return state.merge({
                destiny: {},
                editing: false
            })
        case "SET_EMPTY_MENU":
            return state.merge({
                selected: {
                    icon: "fas fa-check-square",
                },
                editing: true
            })
        case "TOGGLE_DRAWER_MENU":
            return state.merge({
                showDrawer: action.payload
            })
        default:
            return state
    }
}

export default appmenus